import React from "react";

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {}

export function ButtonEditar({
  children,
  className = "",
  type = "button",
  ...props
}: Props) {
  return (
    <button
      type={type}
      className={`
        ${className}

        relative
        overflow-hidden

        flex
        items-center
        justify-center
        gap-2

        w-full
        h-8
        px-8

        rounded-md

        bg-white/5
        backdrop-blur-xl

        border
        border-cyan-300/20

        text-white
        text-sm
        font-medium
        tracking-wide

        transition-all
        duration-300

        hover:-translate-y-0.5
        hover:bg-cyan-400/10
        hover:border-cyan-300/60
        hover:shadow-[0_0_25px_rgba(103,232,249,.35)]

        active:scale-[0.98]
        active:bg-cyan-400/15
      `}
      {...props}
    >
      <span
        className="
          absolute
          inset-0
          bg-gradient-to-br
          from-cyan-300/10
          via-transparent
          to-white/5
          pointer-events-none
        "
      />

      <span className="relative z-10">
        {children}
      </span>
    </button>
  );
}

export default ButtonEditar;